<template>
	<div id="app">
		<!-- 3.使用组件 -->
		<roheader :selected_page="index"></roheader>
		<!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
		<!-- 内容 -->
		<div class="ro-home-content">
			<div class="ro-home-content-box">
				<!-- 科技查引 -->
				<div style="width:1100px;height:349px;margin:auto;overflow: auto;">
					<img :src="cscy_url" style="width:349px;height:349px;float: left;" />
					<div style="float: left;margin-left:50px;text-align: left;width: 700px;">
						<p style="color: #32ccff;">//CHECK AND CHECK</p>
						<h2>科技查新</h2>
						<div style="border-bottom: 2px solid skyblue;width: 40px;margin-bottom: 20px;"></div>
						<h6 style="color:#333;font-size: 14px;">{{cscy_description}}</h6>
						<div style="font-size: 14px;color:#8a8a8a;">如何申请科技查新</div>
						<div style="margin-top: 20px;width: 100%;overflow: hidden;">
							<div class="ro-nodes">
								<el-tooltip content="先注册成本平台用户,如有账户则直接登录" placement="bottom" effect="light">
									<a href="#/pages/login">
										<div class="ro-node" :class="{ active: activeNode === 1 }"
											@mouseover="showNodeInfo(1)" @mouseout="hideNodeInfo">
											<i class="el-icon-user"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-progress-bar" :style="{ width: barWidth }"></div>
											<div class="ro-node-text">注册/登陆</div>
										</div>
									</a>
								</el-tooltip>
								<el-tooltip content="根据规则填写委托单" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcx"> -->
										<div class="ro-node" :class="{ active: activeNode === 2 }"
											@mouseover="showNodeInfo(2)" @mouseout="hideNodeInfo">
											<i class="el-icon-edit"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">填写委托单</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<el-tooltip content="通过支付宝/微信进行支付" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcx"> -->
										<div class="ro-node" :class="{ active: activeNode === 3 }"
											@mouseover="showNodeInfo(3)" @mouseout="hideNodeInfo">
											<i class="el-icon-money"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">付款</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<el-tooltip content="审核员对委托单信息进行初步审核" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcx"> -->
										<div class="ro-node" :class="{ active: activeNode === 4 }"
											@mouseover="showNodeInfo(4)" @mouseout="hideNodeInfo">
											<i class="el-icon-s-check"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">委托审核</div>
										</div>
									<!-- </a> -->
								</el-tooltip>

								<el-tooltip content="根据作者姓名机构等信息进行查询" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcx"> -->
										<div class="ro-node" :class="{ active: activeNode === 5 }"
											@mouseover="showNodeInfo(5)" @mouseout="hideNodeInfo">
											<i class="el-icon-document"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">科技查新</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<!-- <el-tooltip content="核对报告" placement="bottom" effect="light">
									<div class="ro-node" :class="{ active: activeNode === 6 }"
										@mouseover="showNodeInfo(6)" @mouseout="hideNodeInfo">
										<i class="el-icon-folder-checked"
											style="color:white;position: absolute;top:0px;left:1px;"></i>
										<div class="ro-node-text">报告确认</div>
									</div>
								</el-tooltip> -->

								<el-tooltip content="可自行领取报告,也可选择邮寄方式领取" placement="bottom" effect="light">
									<a href="#/user/order">
										<div class="ro-node" :class="{ active: activeNode === 6 }"
											@mouseover="showNodeInfo(6)" @mouseout="hideNodeInfo">
											<i class="el-icon-finished"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">领取报告</div>
										</div>
									</a>
								</el-tooltip>
							</div>
						</div>
						<a href="#/user/kjcx">
							<el-button style="font-size: 20px;" type="primary">立即办理</el-button>
						</a>
					</div>

				</div>
				<!-- 科技查新 -->
				<div style="width:1100px;height:349px;margin:150px auto;">
					<img :src="kjcy_url" style="width:349px;height:349px;float: right;" />
					<div style="overflow: hidden;float: right;margin-right:50px;text-align: right;width: 700px;">
						<p style="color: #32ccff;">//CHECK AND CHECK</p>
						<h2>科技查引</h2>
						<div style="border-bottom: 2px solid skyblue;width: 40px;margin-bottom: 20px;float: right;">
						</div>
						<h6 style="color:#333;font-size: 14px;clear: both;text-align: right;">
							{{kjcy_description}}
						</h6>
						<div style="font-size: 12px;color:#8a8a8a;">如何申请科技查引</div>
						<div style="margin-top: 20px;width: 100%;overflow: hidden;">
							<div class="ro-nodes">
								<el-tooltip content="先注册成本平台用户,如有账户则直接登录" placement="bottom" effect="light">
									<a href="#/pages/login">
										<div class="ro-node" :class="{ active: activeNode_2 === 1 }"
											@mouseover="showNodeInfo_2(1)" @mouseout="hideNodeInfo">
											<i class="el-icon-user"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-progress-bar" :style="{ width: barWidth_2 }"></div>
											<div class="ro-node-text">注册/登陆</div>
										</div>
									</a>
								</el-tooltip>
								<el-tooltip content="根据规则填写委托单" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcy"> -->
										<div class="ro-node" :class="{ active: activeNode_2 === 2 }"
											@mouseover="showNodeInfo_2(2)" @mouseout="hideNodeInfo">
											<i class="el-icon-edit"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">填写委托单</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<el-tooltip content="通过支付宝/微信进行支付" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcy"> -->
										<div class="ro-node" :class="{ active: activeNode_2 === 3 }"
											@mouseover="showNodeInfo_2(3)" @mouseout="hideNodeInfo">
											<i class="el-icon-money"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">付款</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<el-tooltip content="审核员对委托单信息进行初步审核" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcy"> -->
										<div class="ro-node" :class="{ active: activeNode_2 === 4 }"
											@mouseover="showNodeInfo_2(4)" @mouseout="hideNodeInfo">
											<i class="el-icon-s-check"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">委托审核</div>
										</div>
									<!-- </a> -->
								</el-tooltip>

								<el-tooltip content="根据作者姓名机构等信息进行查询" placement="bottom" effect="light">
									<!-- <a href="#/user/kjcy"> -->
										<div class="ro-node" :class="{ active: activeNode_2 === 5 }"
											@mouseover="showNodeInfo_2(5)" @mouseout="hideNodeInfo">
											<i class="el-icon-document"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">课题查引</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<!-- <el-tooltip content="核对报告" placement="bottom" effect="light">
									<div class="ro-node" :class="{ active: activeNode_2 === 6 }"
										@mouseover="showNodeInfo_2(6)" @mouseout="hideNodeInfo">
										<i class="el-icon-folder-checked"
											style="color:white;position: absolute;top:0px;left:1px;"></i>
										<div class="ro-node-text">报告确认</div>
									</div>
								</el-tooltip> -->
								<el-tooltip content="可自行领取报告,也可选择邮寄方式领取" placement="bottom" effect="light">
									<a href="#/user/order">
										<div class="ro-node" :class="{ active: activeNode_2 === 6 }"
											@mouseover="showNodeInfo_2(6)" @mouseout="hideNodeInfo">
											<i class="el-icon-finished"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">领取报告</div>
										</div>
									</a>
								</el-tooltip>
							</div>
						</div>
						<a href="#/user/kjcy">
							<el-button style="font-size: 20px;" type="primary">立即办理</el-button>
						</a>
					</div>
				</div>
				<!-- SCI查收 -->
				<div style="width:1100px;height:349px;margin:auto;">
					<img :src="sci_url" style="width:349px;height:349px;float: left;" />
					<div style="overflow: hidden;float: left;margin-left:50px;text-align: left;width: 700px;">
						<p style="color: #32ccff;">//CHECK AND CHECK</p>
						<h2>SCI查收</h2>
						<div style="border-bottom: 2px solid skyblue;width: 40px;margin-bottom: 20px;"></div>
						<h6 style="color:#333;font-size: 14px;">{{sci_description}}</h6>
						<div style="font-size: 12px;color:#8a8a8a;">如何申请SCI查收</div>
						<div style="margin-top: 20px;width: 100%;overflow: hidden;">
							<div class="ro-nodes">
								<el-tooltip content="先注册成本平台用户,如有账户则直接登录" placement="bottom" effect="light">
									<a href="#/pages/login">
										<div class="ro-node" :class="{ active: activeNode_3 === 1 }"
											@mouseover="showNodeInfo_3(1)" @mouseout="hideNodeInfo">
											<i class="el-icon-user"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-progress-bar" :style="{ width: barWidth_3 }"></div>
											<div class="ro-node-text">注册/登陆</div>
										</div>
									</a>
								</el-tooltip>
								<el-tooltip content="根据规则填写委托单" placement="bottom" effect="light">
									<!-- <a href="#/user/SCI"> -->
										<div class="ro-node" :class="{ active: activeNode_3 === 2 }"
											@mouseover="showNodeInfo_3(2)" @mouseout="hideNodeInfo">
											<i class="el-icon-edit"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">填写委托单</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<el-tooltip content="通过支付宝/微信进行支付" placement="bottom" effect="light">
									<!-- <a href="#/user/SCI"> -->
										<div class="ro-node" :class="{ active: activeNode_3 === 3 }"
											@mouseover="showNodeInfo_3(3)" @mouseout="hideNodeInfo">
											<i class="el-icon-money"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">付款</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<el-tooltip content="审核员对委托单信息进行初步审核" placement="bottom" effect="light">
									<!-- <a href="#/user/SCI"> -->
										<div class="ro-node" :class="{ active: activeNode_3 === 4}"
											@mouseover="showNodeInfo_3(4)" @mouseout="hideNodeInfo">
											<i class="el-icon-s-check"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">委托审核</div>
										</div>
									<!-- </a> -->
								</el-tooltip>

								<el-tooltip content="根据作者姓名机构等信息进行查询" placement="bottom" effect="light">
									<!-- <a href="#/user/SCI"> -->
										<div class="ro-node" :class="{ active: activeNode_3 === 5 }"
											@mouseover="showNodeInfo_3(5)" @mouseout="hideNodeInfo">
											<i class="el-icon-document"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">SCI查引</div>
										</div>
									<!-- </a> -->
								</el-tooltip>
								<!-- <el-tooltip content="核对报告" placement="bottom" effect="light">
									<div class="ro-node" :class="{ active: activeNode_3 === 6 }"
										@mouseover="showNodeInfo_3(6)" @mouseout="hideNodeInfo">
										<i class="el-icon-folder-checked"
											style="color:white;position: absolute;top:0px;left:1px;"></i>
										<div class="ro-node-text">报告确认</div>
									</div>
								</el-tooltip> -->
								<el-tooltip content="可自行领取报告,也可选择邮寄方式领取" placement="bottom" effect="light">
									<a href="#/user/order">
										<div class="ro-node" :class="{ active: activeNode_3 === 6 }"
											@mouseover="showNodeInfo_3(6)" @mouseout="hideNodeInfo">
											<i class="el-icon-finished"
												style="color:white;position: absolute;top:0px;left:1px;"></i>
											<div class="ro-node-text">领取报告</div>
										</div>
									</a>
								</el-tooltip>
							</div>
						</div>
						<a href="#/user/SCI">
							<el-button style="font-size: 20px;" type="primary">立即办理</el-button>
						</a>
					</div>
				</div>
				<!-- 通知公告 -->
				<div style="overflow: hidden;margin-top: 150px;margin-bottom: 50px;">
					<div style="float: left;margin-left:20%;">
						<span style="margin-right:50px;font-size: 2px;font-weight: bold;font-size: 30px;">通知公告</span>
						<img :src="notice_url" />
						<div style="clear: both;width:200px;margin-left:20%;margin-top: 50px;">
							<el-timeline>
								<a :href="notice.url" target="_blank"  v-for="(notice, index) in notice" :key="index" >
								<el-timeline-item :icon="notice.icon"
									type="large" color="#409eff" :timestamp="notice.date">
									<el-card style="width: 500px;text-align: left;">
										<h6>{{notice.title}}</h6>
										<p class="ro-text-overflow">{{notice.subtitle}}</p>
									</el-card>
								</el-timeline-item>
								</a>
							</el-timeline>
						</div>
						<!-- <a v-if="show_find_more" href='..' style='float: right;'>查看更多</a> -->
					</div>
				</div>
			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>
</template>
<script>
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";

	import testprops from "./components/test_props.vue";
	import {
		fetchPost
	} from "@/utils/request"
	export default {
		name: "App",
		data() {
			return {
				index: '首页',
				pages: '首页',
				activeNode: 6, // 当前激活的节点编号
				activeNode_2: 6, // 当前激活的节点编号
				activeNode_3: 6, // 当前激活的节点编号
				showInfo: false, // 是否显示节点详细介绍
				cscy_description: '根据校内外用户需求，查询其学术论文被SCIE、EI、CPCI、CSCD、CSSCI等国内外著名检索工具收录和引用情况，并出具盖有公章的权威检索证明。',
				cscy_url: 'http://kjcx.cqu.edu.cn/static/front/images/ad-cscy.png',

				kjcy_description: '科技查新（也简称“查新”）是指具有其业务资质的机构为委托方在科研立项、新产品开发、申请专利和鉴定科技成果等提供鉴证的一种深层次的信息咨询服务。',
				kjcy_url: 'http://kjcx.cqu.edu.cn/static/front/images/ad-kjcx.png',
				sci_description: '根据校内外用户需求，查询其学术论文被SCIE、EI、CPCI、CSCD、CSSCI等国内外著名检索工具收录和引用情况，并出具盖有公章的权威检索证明。',
				sci_url: 'http://kjcx.cqu.edu.cn/static/front/images/ad-cscy.png',
				show_find_more: false,
				notice_url: 'http://kjcx.cqu.edu.cn/static/front/images/news01.jpg',
				notice: [{
						title: '事件标题',
						content: '事件内容,当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏，当文字超过两行时会自动隐藏',
						date: '2022-04-12 20:46',

					}, {
						title: '事件标题',
						content: '事件内容',
						date: '2022-04-03 20:46',
					}, {
						title: '事件标题',
						content: '事件内容',
						date: '2022-04-03 20:46',
					}, {
						title: '事件标题',
						content: '事件内容',
						date: '2022-04-03 20:46',
					},

				],



			}
		},
		computed: {
			barWidth() {
				return (this.activeNode - 1) * 118 + 'px';
			},
			barWidth_2() {
				return (this.activeNode_2 - 1) * 118 + 'px';
			},
			barWidth_3() {
				return (this.activeNode_3 - 1) * 118 + 'px';
			}
		},
		mounted() {
			this.get_home_setting()
		},

		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			testprops,
		},
		methods: {
			get_home_setting() {
				var self = this
				fetchPost('/ro/tec_search/settings/website/v1').then(response => {
					console.log(response.data)
					self.cscy_description = response.data.list.intro_tech
					self.cscy_url = response.data.list.tech_img

					self.kjcy_description = response.data.list.intro_reference
					self.kjcy_url = response.data.list.reference_img

					self.sci_description = response.data.list.intro_sci
					self.sci_url = response.data.list.sci_img
					self.notice_url = response.data.list.notice_img
					self.notice = response.data.list.notice_list
					// if (response.data.list.notice_list.length > 3) {
					// 	self.show_find_more = true
					// }
					console.log(self.notice)
				})
			},
			showNodeInfo(node) {
				this.activeNode = node;
				this.showInfo = true;
			},
			showNodeInfo_2(node) {
				this.activeNode_2 = node;
				this.showInfo = true;
			},
			showNodeInfo_3(node) {
				this.activeNode_3 = node;
				this.showInfo = true;
			},
			hideNodeInfo() {
				this.showInfo = false;
			}


		},
	};
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ro-home-content {
		width: 100%;
		background: #F0F0F0;
		overflow: auto;
		padding: 20px 0;
		background-image: url(../static/picture/bg-index-3.png);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: cover;
	}


	.ro-home-content-box {
		width: 1140px;
		margin: auto;
		padding: 40px 0;
	}

	.ro-text-overflow {
		overflow: hidden;
		text-overflow: ellipsis;
		/* 将对象作为弹性伸缩盒子模型显示 */
		display: -webkit-box;
		/* 限制在一个块元素显示的文本的行数 */
		/* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
		-webkit-line-clamp: 2;
		/* 设置或检索伸缩盒对象的子元素的排列方式 */
		-webkit-box-orient: vertical;
	}



	.ro-progress-bar {
		position: absolute;
		top: 30%;
		left: 20px;
		width: 60px;
		background-color: dodgerblue;
		transition: width 0.3s ease;
		height: 5px;
	}

	.ro-nodes {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 70px;
	}

	.ro-node {
		position: relative;
		width: 20px;
		height: 20px;
		line-height: 30px;
		border-radius: 50%;
		background-color: #fff;
		border: 1px solid #ccc;
		cursor: pointer;
		margin-right: 80px;
		margin-bottom: 10px;
		color: #000000;
	}

	.ro-node.active {
		background-color: dodgerblue;
		color: dodgerblue;
	}

	.ro-node-text {
		line-height: 50px;
		width: 120px;
		text-align: left;
		font-size: 14px;
		position: absolute;
		top: -35px;
	}
</style>
